export interface ResultNameLetter {
  data: string;
  width: number;
  height: number;
  left: number;
  top: number;
  advance: number;
}

export interface ResultNameArtwork {
  version: 1;
  space: number;
  letters: Record<string, ResultNameLetter>;
}

export function renderNameSvg(name: string, artwork: ResultNameArtwork): string | undefined {
  const placed: { letter: ResultNameLetter; left: number }[] = [];
  let cursor = 0;
  for (const character of name.normalize("NFC")) {
    if (character === " ") {
      cursor += artwork.space;
      continue;
    }
    const letter = artwork.letters[character];
    if (!letter) return undefined;
    placed.push({ letter, left: cursor + letter.left });
    cursor += letter.advance;
  }
  if (!placed.length) return undefined;
  const left = Math.min(...placed.map((item) => item.left)) - 4;
  const top = Math.min(...placed.map((item) => item.letter.top)) - 4;
  const width = Math.max(...placed.map((item) => item.left + item.letter.width)) - left + 4;
  const height = Math.max(...placed.map((item) => item.letter.top + item.letter.height)) - top + 4;
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${Math.ceil(width * 2)}" height="${Math.ceil(height * 2)}" viewBox="${left} ${top} ${width} ${height}">
    ${placed.map((item) => `<image href="${item.letter.data}" x="${item.left}" y="${item.letter.top}" width="${item.letter.width}" height="${item.letter.height}" />`).join("")}
  </svg>`;
}